/**
 * escapeHtml, safeUrl — extracted verbatim from tracking-sdk.js (mechanical split).
 */
'use strict';

  // ===== HTML/URL SAFETY HELPERS =====
  // Agent/LLM output is untrusted (it can carry customer-injected text), so
  // everything interpolated into innerHTML must be escaped, and URLs used in
  // src=/href= attributes must be http(s).
  // Escapes for both element and attribute context (quotes included).
  function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }


  // Returns an attribute-escaped URL if it resolves to http(s), else ''.
  function safeUrl(url) {
    if (!url || typeof url !== 'string') return '';
    const trimmed = url.trim();
    try {
      const parsed = new URL(trimmed, window.location.href);
      if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
        return escapeHtml(trimmed);
      }
    } catch (e) {
      // unparseable → unsafe
    }
    return '';
  }

module.exports = { escapeHtml, safeUrl };
